export const AccountTypeEnum = Object.freeze({
  ADMIN: 'admin',
  CERTIFICATE_ISSUER: 'certificate-issuer',
  // CERTIFICATE_RECEIVER: 'certificate-receiver',
  // CORPORATE_VERIFIER: 'corporate-verifier',
  MIDDLE_MAN: 'middle-man',
  NORMAL_USER: 'normal-user'
});

export const UpgradeRequestEnum = Object.freeze({
  NOT_FOUND: 'not-found',
  PROCESSING: 'processing',
  APPROVED: 'approved',
  DENIED: 'denied'
});

export const RequestStatusEnum = Object.freeze({
  REQUEST_PROCESSING: 'Request Being Processed',
  REQUEST_APPROVED: 'Request Approved'
});

export const UserActionEnum = Object.freeze({
  REQUEST_SENT: 'Request For Event Sent',
  UPLOAD_DATA: 'Upload Data',
  READY_TO_SEND: 'Ready To Send',
  NO_ACTION_REQUIRED: 'No Further Action Required'
});

export const UploadStatusEnum = Object.freeze({
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  UPLOADED: 'UPLOADED',
  CONFIRMED: 'CONFIRMED'
});

export const IssueCertificatesStatus = Object.freeze({
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  ISSUED: 'ISSUED'
});

export const DownloadStatus = Object.freeze({
  DISABLED: 'DOWNLOAD_DISABLED',
  ENABLED: 'DOWNLOAD_ENABLED'
});

export const DownloadQrStatus = Object.freeze({
  DISABLED: 'DOWNLOAD_QR_DISABLED',
  ENABLED: 'DOWNLOAD_QR_ENABLED'
});

export const DownloadExcelStatus = Object.freeze({
  DISABLED: 'DOWNLOAD_EXCEL_DISABLED',
  ENABLED: 'DOWNLOAD_EXCEL_ENABLED'
});

export const UpdateThresholdStatus = Object.freeze({
  DISABLED: 'UPDATE_THRESHOLD_DISABLED',
  ENABLED: 'UPDATE_THRESHOLD_ENABLED'
});

export const DisplayCsvStatus = Object.freeze({
  DISABLED: 'DISPLAY_DISABLED',
  ENABLED: 'DISPLAY_ENABLED'
});

export const ConfirmCsvStatus = Object.freeze({
  DISABLED: 'CONFIRM_CSV_DISABLED',
  ENABLED: 'CONFIRM_CSV_ENABLED'
});

export const NotificationType = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
});
